import { SHIPPING_LABEL } from 'actions/item'

export default (state = null, action) => {
    switch (action.type) {
        case SHIPPING_LABEL:
            if (!!action.error) {
                return action.payload
            } else {
                return action.payload.data;
            }
    }

    return state;
}